export const generateUID = function (force = false) {
	// Handle Session Storage
	const storageKey = 'itdms_uid';

	/**
	 * this.props.track can be
	 * => 0                       => Do not track
	 * => 1                       => Track with any user ID
	 * => a string of any length  => Track with given user ID, f.e. 'sf-lka'
	 */

	/**
	 * Generate new user ID if
	 * => the user should be tracked
	 * AND
	 * => there is no user ID yet |OR| there should be a custom user ID |OR| the generation is enforced
	 */
	if (this.trackUser() && (!sessionStorage.getItem(storageKey) || this.props.track !== '1' || force)) {
		let UID;

		// Generate random user ID if there is no custom ID transferred
		if (this.props.track === '1') {
			UID = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
		} else {
			UID = this.props.track;
		}

		sessionStorage.setItem(storageKey, UID);
	} else if (!this.trackUser()) {
		sessionStorage.removeItem(storageKey);
	}
};

export const trackUser = function () {
	return this.props.track !== '0';
};

export const getStorageFormKey = function () {
	const htmlTag = document.querySelector('html');
	const language = 'lang' in htmlTag ? htmlTag.lang + '_' : '';
	return `itdms_v${this.props.version}_form_${language}${this.state.id}`;
};

export const getSessionData = function () {
	const key = this.getStorageFormKey();
	return sessionStorage.getItem(key) ? JSON.parse(sessionStorage.getItem(key)) : {};
};

export const getUID = function () {
	return sessionStorage.getItem('itdms_uid');
};

export const updateSessionData = function () {
	const data = {
		position: this.state.position,
		userData: this.state.userData,
	};
	sessionStorage.setItem(this.getStorageFormKey(), JSON.stringify(data));
};
